<div
  class="bg-input-background box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="rounded-input relative w-full bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      [id]="id()"
      [placeholder]="label() ?? ''"
      [type]="isPasswordVisible() ? 'text' : 'password'"
      [ngClass]="{
        'border-input-error': hasError,
        'border-input-ring': !hasError,
        'pointer-events-none': ngControl.disabled,
      }"
      class="border-input rounded-input peer p-input focus:border-input-focus text-standard-text w-full bg-transparent placeholder-transparent focus:ring-0" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [for]="id()"
      [ngClass]="{
        'text-input-error': hasError,
        'text-standard-text': !hasError,
      }">
      {{ formattedLabel() }}
    </label>

    @if (!ngControl.control!.disabled) {
      <span
        tabindex="0"
        [id]="id() | appendTestId: 'visibility-switch'"
        [attr.data-testid]="id() | appendTestId: 'visibility-switch'"
        [attr.aria-label]="isPasswordVisible() ? 'sichtbar' : 'nicht sichtbar'"
        class="material-symbols-rounded text-input-label absolute top-3 right-4 bottom-1 h-8 cursor-pointer text-2xl"
        (click)="isPasswordVisible.set(!isPasswordVisible())">
        {{ isPasswordVisible() ? 'visibility_off' : 'visibility' }}
      </span>
    }
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
